<template>
  <responsive-drawer-layout class="DutyCalendarRhbStyle">
    <template v-slot:drawer class="background darken-4"> </template>
    <template v-slot:content>
      <div v-if="smAndDown">
        <v-dialog v-model="isSplitViewCalendarVisible" fullscreen scrollable>
          <v-card>
            <v-card-title class="text-h5" :class="xs ? 'justify-center' : ''">
              <cal-dav-link-button />
              <v-btn text @click="previousMonth" icon>
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <div class="text-h6">{{ currentMonth }}</div>
              <v-btn text @click="nextMonth" icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn text @click="selectToday"> {{ $t('today') }} </v-btn>
            </v-card-title>

            <v-card-text class="background darken-1">
              <duties-month-calendar
                v-if="xs"
                :dutiesByDate="dutiesByDate"
                :month-date="monthDate"
                class="mb-3"
                @onDutySelected="onDutySelected"
              ></duties-month-calendar>
            </v-card-text>
            <v-card-actions class="background darken-1">
              <v-btn @click="isSplitViewCalendarVisible = false">Schliessen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div v-if="!xs" :style="containerStyle" class="d-flex inherit-height pt-2">
        <div style="width: 66%" class="scroll-container">
          <duties-month-calendar :dutiesByDate="dutiesByDate" @onDutySelected="onDutySelected" :month-date="monthDate"></duties-month-calendar>
        </div>
        <div style="width: 34%" class="background pt-2 mb-2 mx-2 scroll-container">
          <duty-activities
            v-if="dutyActivities && dutyActivities.length > 0"
            style="height: 100%"
            :mergeAllDuties="mergeAllDuties"
            :duty="selectedDuty"
            :dutyActivities="dutyActivities"
          ></duty-activities>
          <div v-else class="pr-5 pt-8 full-width text-center">Kein Dienst gewählt</div>
        </div>
      </div>
      <div v-if="xs" :style="containerStyle" class="d-flex inherit-height pt-2">
        <div style="width: 100%" class="background pt-2 mx-2 mb-2 scroll-container">
          <duty-activities
            v-if="dutyActivities && dutyActivities.length > 0"
            style="height: 100%"
            :mergeAllDuties="mergeAllDuties"
            :duty="selectedDuty"
            :dutyActivities="dutyActivities"
          ></duty-activities>
          <div v-else class="pr-5 pt-8 full-width text-center">Kein Dienst gewählt</div>
        </div>
      </div>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import { mapState } from 'vuex';
import MODULE_ID from '@/modules/myDuties/moduleId';
import dateUtils from '@/common/dateUtils';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import { DAY_IN_MS } from '@/common/constants';
import DutiesMonthCalendar from '@/modules/myDuties/views/DutiesMonthCalendar';
import DutyActivities from '@/modules/myDuties/dutyActivities/DutyActivities.vue';
import CalDavLinkButton from '@/components/buttons/CalDavLinkButton.vue';

export default {
  name: 'Dutycalendarrhbstyle',
  mixins: [common, configMixin, dateTimeMixin, dutyMixin],
  components: {
    ResponsiveDrawerLayout,
    DutiesMonthCalendar,
    DutyActivities,
    CalDavLinkButton,
  },
  props: {
    moduleConfig: Object,
  },
  created() {
    let monthDate = new Date();
    monthDate.setDate(1);
    this.firsOfCalendarMonth = monthDate;
  },
  mounted() {
    let today = new Date();
    this.selectedDuty = this.dutiesByDate[dateUtils.formatDateAsYYYYMMDD(today)];
    if (!this.selectedDuty) {
      this.isSplitViewCalendarVisible = true;
    }
    console.debug('selected duty', JSON.stringify(this.selectedDuty, null, 2));
  },
  data() {
    return {
      isCalendarVisibleOnSmAndDown: true,
      selectedDuty: null,
      mergeAllDuties: false,
      monthDate: null, // any date in the month to display in calendar view
    };
  },

  computed: {
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    ...mapState(MODULE_ID, ['duties', 'dutiesDisplayMode', 'dutiesById']),
    isSplitViewCalendarVisible: {
      // getter
      get() {
        console.debug('get isSplitViewCalendarVisible');
        return this.$store.state.meinDienst.isSplitViewCalendarVisible;
      },
      // setter
      set(value) {
        this.$store.commit('meinDienst/setIsSplitViewCalendarVisible', value, { root: true });
      },
    },
    firsOfCalendarMonth: {
      get() {
        return this.$store.state.meinDienst.firsOfCalendarMonth;
      },
      set(value) {
        this.$store.commit(`meinDienst/setFirsOfCalendarMonth`, value);
      },
    },
    containerStyle() {
      if (this.moduleConfig.backgroundImg) {
        return {
          backgroundImage: `url(${this.assetUrl(this.moduleConfig.backgroundImg)}`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        };
      }
      return null;
    },
    dutyActivities() {
      // console.debug('calculate dutyActivities this.mergeFromDutyActivityId', this.mergeFromDutyActivityId);
      if (this.selectedDuty) {
        let dutyActivities = this.mx_getDutyActivities(this.selectedDuty, {
          tenant: this.tenant,
        });
        console.debug('dutyActivities ind DutyView', dutyActivities);
        return dutyActivities;
      }

      return [];
    },
    dutiesByDate() {
      let dutiesByDate = {};
      this.duties.forEach((duty) => {
        let dutyDate = dateUtils.parseISOString(duty.day);
        dutiesByDate[dateUtils.formatDateAsYYYYMMDD(dutyDate)] = duty;
      });
      console.debug('dutiesByDate', JSON.stringify(dutiesByDate, null, 2));
      return dutiesByDate;
    },

    locale() {
      return this.$store.state.language.locale;
    },
  },
  methods: {
    onDutySelected(duty) {
      this.selectedDuty = duty;
      this.isSplitViewCalendarVisible = false;
    },
    getDate(weekOfMonth, weekDayNum) {
      let firstOfMonth = this.firsOfCalendarMonth; // new Date(this.year, this.month, 1);
      let dateInTopLeftCorner = new Date(firstOfMonth.getTime() - firstOfMonth.getDay() * DAY_IN_MS);
      let dateInMatrix = new Date(dateInTopLeftCorner.getTime() + ((weekOfMonth - 1) * 7 + weekDayNum) * DAY_IN_MS);
      console.debug('dateInMatrix', dateInMatrix);
      return dateInMatrix;
    },

    getMonthTitle(yearMonth) {
      let yearAndMonth = yearMonth.split('_');
      let date = new Date();
      date.setYear(yearAndMonth[0]);
      date.setMonth(yearAndMonth[1]);
      return dateUtils.formatAsLocaleYearAndMonth(date, this.locale);
    },

    time(minutesAfterMidnight) {
      return this.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight);
      //return this.getTimeFromMinutesAfterMidnight(this.moduleConfig.timeFormat, minutesAfterMidnight);
    },
  },
};
</script>

<style scoped></style>
